import {
  camect as camectUrl,
  dealerApi as dealerApiUrl,
  jobs as jobsUrl,
  jobStat as jobStatUrl,
  legacyVk as legacyVkUrl,
  logos as logosUrl,
  odata as odataUrl,
  odataEventHistories as odataEventHistoriesUrl,
  odataEventReports as odataEventReportsUrl,
  pulse as pulseUrl,
  thirdPartyVideo as thirdPartyVideoUrl,
  vk as vkUrl,
} from "config/urls";
export const vkEndpoint = (path) => `${vkUrl}${path}`;
export const legacyVkEndpoint = (path) => `${legacyVkUrl}${path}`;
export const odataEndpoint = (path) => `${odataUrl}${path}`;
export const jobsEndpoint = (path) => `${jobsUrl}${path}`;
export const jobStatEndpoint = (path) => `${jobStatUrl}${path}`;
export const dealerApiEndpoint = (path) => `${dealerApiUrl}${path}`;
export const thirdPartyVideoEndpoint = (path) => `${thirdPartyVideoUrl}${path}`;
export const camectEndpoint = (path) => `${camectUrl}${path}`;
export const pulseEndpoint = (path) => `${pulseUrl}${path}`;
export const logosEndpoint = (path) => `${logosUrl}${path}`;
export const odataEventReportsEndpoint = (path) =>
  `${odataEventReportsUrl}${path}`;
export const odataEventHistoriesEndpoint = (path) =>
  `${odataEventHistoriesUrl}${path}`;
